import React, { Component } from "react";
import { connect } from "react-redux";
import { Spin } from "antd";
import { LoginBackground } from "styled/common-styled";
import { checkOauthLogin, removeCredentials } from "../actions";
import { checkLogin } from "modules/auth/actions";
import OauthForm from "./Form";
import LoginForm from "modules/auth/components/Login";

class OauthLogin extends Component {
  componentDidMount() {
    const url = new URL(window.location.href);
    const code = url.searchParams.get("code");
    const verifier = sessionStorage.getItem("pkce_verifier");
    if (code && verifier) {
      sessionStorage.removeItem("pkce_verifier");
      window.history.replaceState({}, "", url.pathname);
      this.props.checkOauthLogin({ code, code_verifier: verifier, type: "Azure" });
    }
  }

  onSubmitOauth = values => {
    this.props.checkOauthLogin(values);
  };

  render() {
    const pathname = window.location.pathname;

    const isLoginQC = pathname === "/loginqc";

    return (
      <LoginBackground>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100vh",
          }}
        >
          <div
            style={{
              backgroundColor: "#fff",
              padding: "40px",
              borderRadius: "16px",
              boxShadow: "0 20px 60px rgba(0, 0, 0, 0.4)",
              width: "400px",
            }}
          >
            <div style={{ textAlign: "center", marginBottom: "8px" }}>
              <img src="/img/smartquality2-web-red.png" alt="logo" width="75%" />
            </div>
            {isLoginQC ? (
              <>
                <p style={{ textAlign: "center", color: "#8c8c8c", fontSize: "13px", marginBottom: "24px", marginTop: "4px" }}>
                  SmartQuality Account
                </p>
                <div
                  style={{ color: "#dc2626", cursor: "pointer", marginBottom: "16px", fontSize: "13px" }}
                  onClick={() => window.history.back()}
                >
                  &larr; Back
                </div>
                <LoginForm auth={this.props.auth} noLayout={true} />
              </>
            ) : (
              <>
                <p style={{ textAlign: "center", color: "#8c8c8c", fontSize: "13px", marginBottom: "24px", marginTop: "4px" }}>
                  เข้าสู่ระบบด้วยบัญชีองค์กรของคุณ
                </p>
                <Spin spinning={this.props.oauth.loading} size="large">
                  <OauthForm auth={this.props.oauth} onSubmit={this.onSubmitOauth} />
                </Spin>
              </>
            )}
          </div>
        </div>
      </LoginBackground>
    );
  }
}

export default connect(
  ({ auth, oauth }) => ({ auth, oauth }),
  {
    checkLogin: checkLogin.request,
    checkOauthLogin: checkOauthLogin.request,
    removeCredentials,
  }
)(OauthLogin);
